import { Dispatch, SetStateAction, createContext } from 'react';

import { AuthSessionState } from './useAuth.utils';

export const AuthContext = createContext<
  [AuthSessionState, Dispatch<SetStateAction<AuthSessionState>>]
>([undefined, () => void 0]);
